import { dataURItoBlob } from '@/utils/fs/image.utils';
import MyWorker from './image-not-transparent-worker?worker';

const webWorkers: Worker[] = [];

/**
 * 获取图片非透明区域面积
 * @param data
 * @returns 返回非透明区域面积
 */
export const getImageNotTransparentAreaByWorker = async (data: {
  imageUrl: string;
  width: number;
  height: number;
  index: number;
}) => {
  const { imageUrl, index = 0, height, width } = data;
  const imageBlob = dataURItoBlob(imageUrl);
  if (!webWorkers[index]) webWorkers[index] = new MyWorker();
  const myWorker = webWorkers[index];
  return new Promise<number>((resolve, reject) => {
    myWorker.onmessage = (e: {
      data: {
        area: number;
      };
    }) => {
      const res = e.data;

      if (res) {
        resolve(res.area);
      } else {
        reject();
      }
    };
    myWorker.onerror = () => {
      reject('web worker发生错误');
    };

    // postMessage to worker
    myWorker.postMessage({
      // img: imageDom,
      imageBlob: imageBlob,
      width: width,
      height: height
    });
  });
};

export const terminateWebworkers = () => {
  webWorkers.forEach((worker) => {
    worker.terminate();
  });
  webWorkers.length = 0;
};
